const API = "/api";

async function req(path, body, method = "POST") {
    const res = await fetch(API + path, {
        method,
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: body ? JSON.stringify(body) : null
    });

    const text = await res.text();
    let data = {};
    try { data = JSON.parse(text); } catch { data = { raw: text }; }

    if (!res.ok) {
        const err = new Error((data && data.error) ? data.error : "request_failed");
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}


export function getDeviceId() {
    const key = "rc_device_id";
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const id =
        (crypto && crypto.randomUUID && crypto.randomUUID()) ||
        Array.from(crypto.getRandomValues(new Uint8Array(16)))
            .map((b) => b.toString(16).padStart(2, "0"))
            .join("");
    localStorage.setItem(key, id);
    return id;
}

export const api = {
    login: (username, password) => req("/auth_login.php", { username, password, device_id: getDeviceId() }),
    me: () => req("/auth_me.php", null),
    logout: () => req("/auth_logout.php", null),

    verify: (name, rc) => req("/rc_verify.php", { name, rc }),
    register: (name, rc, note) => req("/rc_register.php", { name, rc, note }),

    usersCreate: (username, password) => req("/users_create.php", { username, password }),
    usersSetRole: (user_id, role) => req("/users_set_role.php", { user_id, role }),

    changePassword: (old_password, new_password) => req("/auth_change_password.php", { old_password, new_password })
};
